// src/components/QuotationDocument.js
import React from 'react';
import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
  Font,
  Svg, Path, 
} from '@react-pdf/renderer';
import { bahttext } from 'bahttext';
// โลโก้ย่อสำหรับ PDF (ต้นฉบับ 3287px ทำให้สร้าง PDF/รูปช้ามาก — แสดงจริงแค่ 80pt)
import logo from '../../assets/logo-pdf.png';

// 1. ลงทะเบียนฟอนต์ Sarabun (รองรับไทยครบ)
Font.register({
  family: 'Sarabun',
  fonts: [
    {
      src: '/fonts/Sarabun-Regular.ttf',
      format: 'truetype',
      fontWeight: 'normal', 
      fontStyle:  'normal',  
    },
    {
      src: '/fonts/Sarabun-Italic.ttf',
      format: 'truetype',
      fontWeight: 'normal',
      fontStyle:  'italic',
    },
    {
      src: '/fonts/Sarabun-Bold.ttf',
      format: 'truetype',
      fontWeight: 'bold', 
      fontStyle:  'normal',
    },
  ],
});

const fmt = (num) =>
  new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
}).format(num);

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Sarabun',
    fontSize: 11,
    padding: 12,
    lineHeight: 1.2,
  },
  boldText: {
    fontWeight: 'bold',
  },

  // Header
  header: { flexDirection: 'row', marginBottom: 4 },
  logo: { width: 80, height: 50 },
  headerCenter: { flex: 1, paddingLeft: 8 },
  compName: { fontSize: 14, fontWeight: 'bold', marginBottom: 6 },
  compSub: { fontSize: 9 },
  titleColumn: {
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  titleBox: {
    width: 110,
    backgroundColor: '#E5E4E2',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 4,
  },
  titleThai: { fontSize: 14, fontWeight: 'bold' },
  titleEng: { fontSize: 10, marginTop: 2 },
  taxText: {
    fontSize: 9,
    marginTop: 2,
    textAlign: 'right',
  },

  // Info sections
  infoContainer: {
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 6,
    marginTop: 4,
    marginBottom: 4,
  },
  infoLeft: {
    flex: 4,
    padding: 6,
    borderRightWidth: 1,
    borderColor: '#000',
  },
  labelLeft: { width: '30%', fontWeight: 'bold', fontSize: 10 },
  valueLeft: { width: '70%', fontSize: 10 },
  infoRight: { flex: 2, padding: 6 },
  infoRow: { flexDirection: 'row', marginBottom: 2 },
  label: { width: '40%', fontWeight: 'bold', fontSize: 10 },
  value: { width: '60%', fontSize: 10 },

  // Table
  table: {
    width: '100%',
    borderWidth: 1,
    borderColor: '#000',
    marginBottom: 4,
    marginTop: 4,
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#EEE',
    borderBottomWidth: 1,
    borderColor: '#000',
    paddingVertical: 4,
  },
  tableRow: {
    flexDirection: 'row',
    padding: 4,
  },
  colNo: {
    width: '5%',
    fontSize: 10,
    paddingLeft: 4,
  },
  colDesc: {
    width: '48%',
    fontSize: 10,
    paddingLeft: 4,
    paddingRight: 4,
  },
  colQty: {
    width: '11%',
    textAlign: 'right',
    fontSize: 10,
    paddingLeft: 4,
    paddingRight: 4,
  },
  colUnit: {
    width: '12%',
    textAlign: 'center',
    fontSize: 10,
  },
  colPrice: {
    width: '12%',
    textAlign: 'right',
    fontSize: 10,
    paddingLeft: 4,
    paddingRight: 4,
  },
  colAmt: {
    width: '12%',
    textAlign: 'right',
    fontSize: 10,
    paddingLeft: 4,
    paddingRight: 4,
  },
  headerCol: {
    textAlign: 'center',
    fontWeight: 'bold',
  },

  bottomSection: {
    flexDirection: 'row',
    marginTop: 4,
  },

  // เงื่อนไข
  condBox: {
    flex: 1,
    borderWidth: 1,
    borderColor: '#000',
    padding: 6,
    paddingRight: 43,
    borderRadius: 4,
    marginRight: 8,
  },
  condTitle: {
    fontWeight: 'bold',
    marginBottom: 4,
    fontSize: 10,
  },
  condRow3: {
    flexDirection: 'row',
    marginBottom: 2,
    alignItems: 'center',
  },
  square: {
    width: 10,
    height: 10,
    borderWidth: 1,
    borderColor: '#000',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 4,
  },
  condCell: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  condCellLabel: {
    fontSize: 10,
  },

  // สรุปยอด
  sumBox: {
    flex: 1,
    borderWidth: 1,
    borderColor: '#000',
    padding: 15,
    borderRadius: 4,
    paddingVertical: 6,
    paddingHorizontal: 15,
  },
  sumRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 2,
  },
  sumLabel: {
    fontWeight: 'bold',
    fontSize: 10,
  },
  sumValue: {
    fontSize: 10,
    textAlign: 'right',
    fontWeight: 'bold',
  },
  wordsBox: {
    backgroundColor: '#eee',
    padding: 4,
    marginTop: 4,
    borderRadius: 2,
  },
  words: {
    fontSize: 10,
    textAlign: 'center',
    fontStyle: 'italic',
  },

  // Footer
  footerRow: {
    flexDirection: 'row',
    marginTop: 8,
  },
  remarkBox: {
    flex: 1,
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 6,
    padding: 6,
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: 60,
    marginRight: 4,
  },
  remarkText: {
    fontSize: 10,
  },
  remarkSubText: {
    fontSize: 8,
  },

  signatureRow: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  signBox: {
    flex: 1,
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 6,
    alignItems: 'center',
    padding: 6,
    marginLeft: 4,
  },
  signTitle: {
    fontSize: 10,
    marginBottom: 4,
    fontWeight: 'bold',
  },
  signName: {
    fontSize: 10,
    marginBottom: 2,
  },
  signUnderLine: {
    fontSize: 10,
    marginBottom: 4,
  },
  signDate: {
    fontSize: 10,
  },
});

// ── แบ่งรายการสินค้าเป็นหลายหน้า (ทุกหน้าใช้ฟอร์มเดิมครบชุด) ──────────────
// ความสูงเป็นหน่วย pt ของ A4 (842pt) — ประมาณจาก styles ด้านบน
const ROW_PT = 20;          // แถวสินค้า 1 บรรทัด (fontSize 10 × lineHeight 1.2 + padding 4×2)
const LINE_PT = 12;         // บรรทัดที่ตัดขึ้นใหม่ในแถวเดียวกัน
const ITEMS_AREA_PT = 370;  // พื้นที่สำหรับแถวสินค้าต่อหน้า เมื่อส่วนอื่นอยู่ในขนาดปกติ
const DESC_WIDTH_PT = 265;  // ความกว้างข้อความในคอลัมน์รายการสินค้า (48%)
const WRAP_FACTOR = 0.85;   // ตัดบรรทัดตามคำ ทำให้ใช้ความกว้างได้ไม่เต็มบรรทัด

// ความกว้างตัวอักษร Sarabun ที่ fontSize 10 (pt) — สระบน/ล่างและวรรณยุกต์ไม่กินความกว้าง
const charWidth = (ch) => {
  if (/[ัิ-ฺ็-๎]/.test(ch)) return 0;
  if (/[ก-๛]/.test(ch)) return 6.0;
  if (/[0-9]/.test(ch)) return 5.5;
  if (/[A-Z]/.test(ch)) return 6.0;
  if (/[a-z]/.test(ch)) return 4.8;
  if (ch === ' ') return 2.4;
  return 3.4;
};

const estLines = (text, widthPt, fontSize = 10) => {
  const w = [...String(text ?? '')].reduce((acc, ch) => acc + charWidth(ch), 0) * (fontSize / 10);
  return Math.max(1, Math.ceil(w / (widthPt * WRAP_FACTOR)));
};

function paginateItems(items, areaPt) {
  const pages = [];
  let current = [];
  let used = 0;
  items.forEach((it) => {
    const h = ROW_PT + (estLines(it.item_name, DESC_WIDTH_PT) - 1) * LINE_PT;
    if (current.length > 0 && used + h > areaPt) {
      pages.push(current);
      current = [];
      used = 0;
    }
    current.push(it);
    used += h;
  });
  pages.push(current);
  return pages;
}


export default function QuotationDocument({
  cartHeader,
  customer,
  salesperson,
  doc_no,
  branchInfo,
  companyProfile,
  items,
  discount,
  appliedPromos = [],
  promoDiscount = 0,
  loyaltyDiscount = 0,
  loyaltyPointsRedeemed = 0,
}) {
  // totals
  const sumItems = items.reduce((acc, i) => acc + i.qty * i.price, 0);
  const grandTotal = sumItems - discount - promoDiscount - loyaltyDiscount;
  const beforeTax = +(grandTotal / 1.07).toFixed(2);
  const vat = +(grandTotal - beforeTax).toFixed(2);

const Checkbox = ({ checked }) => (
  <View style={styles.square}>
    {checked && (
      <Svg
        width={10}
        height={10}
        viewBox="0 0 24 24"
      >
        <Path
          d="M20 6 L9 17 L4 12"
          stroke="#000"
          strokeWidth={2}
          fill="none"
        />
      </Svg>
    )}
  </View>
);

  // พื้นที่แถวสินค้าต่อหน้า = พื้นที่ปกติ − ส่วนที่สูงขึ้นตามข้อมูล (สาขา/ที่อยู่/โปรโมชัน/หมายเหตุ)
  const visiblePromos = appliedPromos.filter(p => !p.is_free_gift);
  const branchExtraPt = branchInfo.reduce(
    (acc, b) => acc + estLines(`${b.branch_label}: ${b.address}  โทรศัพท์. ${b.telephone}`, 373, 9) * 10.8,
    0,
  ) - 10.8;
  const infoExtraPt =
    (estLines(customer.name_1, 257) - 1) * LINE_PT +
    (estLines(`${customer.address ?? ''} ${customer.zip_code ?? ''}`, 257) - 1) * LINE_PT;
  const sumExtraPt =
    (visiblePromos.length + (promoDiscount > 0 ? 1 : 0) + (loyaltyDiscount > 0 ? 1 : 0)) * 14 -
    (cartHeader.set_tax_type === '' ? 0 : 30);
  // กล่องหมายเหตุสูงได้ถึงเท่ากล่องเซ็นชื่อ (~3 บรรทัด) โดยไม่ดันหน้า
  const remarkExtraPt = Math.max(0, estLines(`หมายเหตุ: ${cartHeader.remark ?? ''}`, 267) - 3) * LINE_PT;
  const itemsAreaPt = Math.max(
    ROW_PT * 3,
    ITEMS_AREA_PT - Math.max(0, branchExtraPt) - infoExtraPt - sumExtraPt - remarkExtraPt,
  );
  const pages = paginateItems(items, itemsAreaPt);
  const pageStarts = pages.map((_, p) =>
    pages.slice(0, p).reduce((acc, pg) => acc + pg.length, 0),
  );

  return (
    <Document>
      {pages.map((pageItems, p) => {
        const isLast = p === pages.length - 1;
        const startIndex = pageStarts[p];
        // หน้าที่ยังไม่ใช่หน้าสุดท้าย: คงกรอบสรุปยอดเดิมแต่ไม่แสดงตัวเลข
        const showAmt = (v) => (isLast ? v : '\u200B');
        return (
      <Page key={p} size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <Image src={logo} style={styles.logo} />
          <View style={styles.headerCenter}>
            <Text style={styles.compName}>
              {companyProfile.company_name_1}{'\u200B'}
            </Text>
            {branchInfo.map((b, i) => (
              <Text key={i} style={styles.compSub}>
                  {b.branch_label}: {b.address}  โทรศัพท์. {b.telephone}
              </Text>
            ))}
            <Text style={styles.compSub}>
              Email {companyProfile.email}
            </Text>
          </View>
            <View style={styles.titleColumn}>
            <View style={styles.titleBox}>
              <Text style={styles.titleThai}>ใบเสนอราคา</Text>
              <Text style={styles.titleEng}>QUOTATION</Text>
            </View>
            {/* เลขภาษี วางใต้กรอบ */}
            <Text style={styles.taxText}>
              เลขประจำตัวผู้เสียภาษี{'\u200B'}: {companyProfile.tax_number}
            </Text>
          </View>
        </View>

        {/* Customer & Doc Info */}
        <View style={styles.infoContainer}>
          <View style={styles.infoLeft}>
            <View style={styles.infoRow}>
              <Text style={styles.labelLeft}>ชื่อลูกค้า:</Text>
              <Text style={styles.valueLeft}>
                {customer.name_1}{'\u200B'}
                {customer.ar_status === 1 ? `  (${customer.branch_label})`: ''}{'\u200B'}
              </Text>
            </View>
            <View style={styles.infoRow}>
              <Text style={styles.labelLeft}>ที่อยู่:</Text>
              <Text style={styles.valueLeft}>
                {customer.address}{'\u200B'} {customer.zip_code}
              </Text>
            </View>
            <View style={styles.infoRow}>
              <Text style={styles.labelLeft}>โทร:</Text>
              <Text style={styles.valueLeft}>{customer.telephone}{'\u200B'}</Text>
            </View>
            <View style={styles.infoRow}>
              <Text style={styles.labelLeft}>เลขประจำตัวผู้เสียภาษี{'\u200B'}:</Text>
              <Text style={styles.valueLeft}>
                {customer.ar_status === 1 ? customer.tax_id : customer.card_id}
                {customer.ar_status === 1 && (
                  <Text>
                    {'                                           '}
                    <Text style={styles.boldText}>สาขา: </Text>
                    {customer.branch_code}
                  </Text>
                )}
              </Text>
            </View>
          </View>
          <View style={styles.infoRight}>
            <View style={styles.infoRow}>
              <Text style={styles.label}>วันที่เอกสาร:</Text>
              <Text style={styles.value}>{cartHeader.doc_date}</Text>
            </View>
            <View style={styles.infoRow}>
              <Text style={styles.label}>เลขที่เอกสาร:</Text>
              <Text style={styles.value}>{doc_no}</Text>
            </View>
            <View style={styles.infoRow}>
              <Text style={styles.label}>พนักงานขาย:</Text>
              <Text style={styles.value}>{salesperson.name}{'\u200B'}</Text>
            </View>
          </View>
        </View>

        {/* Items Table */}
        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={[styles.colNo, styles.headerCol]}>ลำดับ{'\u200B'}</Text>
            <Text style={[styles.colDesc, styles.headerCol]}>รายการสินค้า</Text>
            <Text style={[styles.colQty, styles.headerCol]}>จำนวน{'\u200B'}</Text>
            <Text style={[styles.colUnit, styles.headerCol]}>หน่วย</Text>
            <Text style={[styles.colPrice, styles.headerCol]}>ราคา</Text>
            <Text style={[styles.colAmt, styles.headerCol]}>จำนวนเงิน{'\u200B'}</Text>
          </View>
          {pageItems.map((it, i) => (
            <View key={`${it.item_code}-${startIndex + i}`} style={[
              styles.tableRow,
              // ถ้าเป็นแถวสุดท้ายของหน้า ให้เว้นที่ว่างด้านล่าง
              i === pageItems.length - 1 && { paddingBottom: 50 },
            ]}>
              <Text style={styles.colNo}>{startIndex + i + 1}</Text>
              <Text style={styles.colDesc}>{it.item_name}{'\u200B'}</Text>
              <Text style={styles.colQty}>{fmt(Number(it.qty))}</Text>
              <Text style={styles.colUnit}>{it.unit_code}{'\u200B'}</Text>
              <Text style={styles.colPrice}>{fmt(Number(it.price))}</Text>
              <Text style={styles.colAmt}>
                {fmt(Number(it.qty) * Number(it.price))}
              </Text>
            </View>
          ))}
          {/* absolute vertical lines */}
          {['5%','52%','64%','76%','88%'].map((left,i)=>(
            <View
              key={i}
              style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left,
                width: 1,
                backgroundColor: '#000'
              }}
            />
          ))}
        </View>

        {/* Conditions + Summary */}
        {/* Conditions + Summary */}
        <View style={styles.bottomSection}>

          {/* เงื่อนไข */}
          <View style={styles.condBox} wrap={false}>
            {/* หัว */}
            <Text style={styles.condTitle}>เงื่อนไข:</Text>

            {/* แถว 1: ราคาสินค้า */}
            <View style={styles.condRow3}>
              <View style={styles.condCell}>
                <Text style={styles.condCellLabel}>ราคาสินค้า</Text>
              </View>
              <View style={styles.condCell}>
                <Checkbox checked={cartHeader.inquiry_type===1} />
                <Text style={styles.condCellLabel}>เงินสด</Text>
              </View>
              <View style={styles.condCell}>
                <Checkbox checked={cartHeader.inquiry_type===0} />
                <Text style={styles.condCellLabel}>
                  เครดิต {cartHeader.credit_day} วัน
                </Text>
              </View>
            </View>

            {/* แถว 2: ภาษี */}
            <View style={styles.condRow3}>
              <View style={styles.condCell}>
                <Text style={styles.condCellLabel}>ภาษี</Text>
              </View>
              <View style={styles.condCell}>
                <Checkbox checked={cartHeader.set_tax_type==='novat'} />
                <Text style={styles.condCellLabel}>ไม่รวมภาษี</Text>
              </View>
              <View style={styles.condCell}>
                <Checkbox checked={cartHeader.set_tax_type===''} />
                <Text style={styles.condCellLabel}>รวมภาษี</Text>
              </View>
            </View>

            {/* แถว 3: ค่าขนส่ง */}
            <View style={styles.condRow3}>
              <View style={styles.condCell}>
                <Text style={styles.condCellLabel}>ค่าขนส่ง</Text>
              </View>
              <View style={styles.condCell}>
                <Checkbox checked={cartHeader.send_type===0} />
                <Text style={styles.condCellLabel}>ไม่รวมค่าขนส่ง</Text>
              </View>
              <View style={styles.condCell}>
                <Checkbox checked={cartHeader.send_type===1} />
                <Text style={styles.condCellLabel}>รวมค่าขนส่ง</Text>
              </View>
            </View>
          </View>

          {/* สรุปยอด */}
          <View style={styles.sumBox} wrap={false}>
            <View style={styles.sumRow}>
              <Text style={styles.sumLabel}>ส่วนลด</Text>
              <Text style={styles.sumValue}>{showAmt(fmt(cartHeader.discount))}</Text>
            </View>
            {visiblePromos.map((p, i) => (
              <View key={i} style={styles.sumRow}>
                <Text style={[styles.sumLabel, { fontSize: 8, color: '#2e7d32' }]}>{p.promotion_name}</Text>
                <Text style={[styles.sumValue, { color: '#2e7d32' }]}>{showAmt(`-${fmt(p.discount_amount)}`)}</Text>
              </View>
            ))}
            {promoDiscount > 0 && (
              <View style={styles.sumRow}>
                <Text style={[styles.sumLabel, { fontSize: 8 }]}>ส่วนลดโปรโมชันรวม</Text>
                <Text style={styles.sumValue}>{showAmt(`-${fmt(promoDiscount)}`)}</Text>
              </View>
            )}
            {loyaltyDiscount > 0 && (
              <View style={styles.sumRow}>
                <Text style={[styles.sumLabel, { fontSize: 8 }]}>
                  {`แลกแต้ม (${loyaltyPointsRedeemed} แต้ม)`}
                </Text>
                <Text style={styles.sumValue}>{showAmt(`-${fmt(loyaltyDiscount)}`)}</Text>
              </View>
            )}
            {cartHeader.set_tax_type === '' && (
              <>
              <View style={styles.sumRow}>
                <Text style={styles.sumLabel}>จำนวนเงินรวมก่อนภาษี{'\u200B'}</Text>
                <Text style={styles.sumValue}>{showAmt(fmt(beforeTax))}</Text>
              </View>
              <View style={[styles.sumRow, { marginTop: 2 }]}>
                <Text style={styles.sumLabel}>ภาษีมูลค่าเพิ่ม 7%</Text>
                <Text style={styles.sumValue}>{showAmt(fmt(vat))}</Text>
              </View>
              </>
            )}
            <View style={[styles.sumRow, { marginTop: 4 }]}>
              <Text style={[styles.sumLabel, { fontSize: 10 }]}>
                จำนวนเงินรวมทั้งสิ้น{'\u200B'}
              </Text>
              <Text style={[styles.sumValue, { fontSize: 10 }]}>
                {showAmt(fmt(grandTotal))}
              </Text>
            </View>
            <View style={styles.wordsBox}>
              <Text style={styles.words}>
                {isLast ? bahttext(grandTotal) : '(มีต่อหน้าถัดไป)'}
              </Text>
            </View>
          </View>
        </View>


        <View style={styles.footerRow}>

          {/* กล่องหมายเหตุ (เหลือพื้นที่ซ้าย) */}
          <View style={styles.remarkBox}>
            <Text style={styles.remarkText}>
              <Text style={styles.boldText}>หมายเหตุ: </Text>{cartHeader.remark}{'\u200B'}
            </Text>
            <Text style={styles.remarkSubText}>
              **อาจมีการเปลี่ยนแปลงราคาโดยไม่ได้แจ้งให้ทราบล่วงหน้า{'\n'}
              **เมื่อมีการยืนยันการสั่งซื้อ ทางบริษัทฯจะไม่รับเปลี่ยนหรือคืนสินค้าไม่ว่ากรณีใดๆทั้งสิ้น
            </Text>
          </View>

          {/* กล่องเซ็น 2 อัน */}
          <View style={styles.signatureRow}>
            {/* ผู้เสนอราคา */}
            <View style={styles.signBox}>
              <Text style={styles.signTitle}>ผู้เสนอราคา</Text>
              <View style={{ height: 5 }} />
              <Text style={styles.signName}>{salesperson.name}{'\u200B'}</Text>
              <Text style={styles.signUnderLine}>…………………………………</Text>
              <Text style={styles.signName}>พนักงานขาย</Text>
              <Text style={styles.signDate}>วันที่ {cartHeader.doc_date}</Text>
            </View>

            {/* ผู้อนุมัติ/ลูกค้า */}
            <View style={styles.signBox}>
              <Text style={styles.signTitle}>สำหรับลูกค้า{'\u200B'}</Text>
              <View style={{ height: 20 }} />
              <Text style={styles.signUnderLine}>…………………………………</Text>
              <Text style={styles.signName}>ผู้อนุมัติการสั่งซื้อ</Text>
              <Text style={styles.signDate}>วันที่ …………./…………/…………</Text>
            </View>
          </View>

        </View>

        {/* เลขหน้า — อยู่ในขอบล่างของกระดาษ ไม่กินพื้นที่ฟอร์ม */}
        {pages.length > 1 && (
          <Text fixed style={{ position: 'absolute', bottom: 2, right: 12, fontSize: 8 }}>
            หน้า {p + 1}/{pages.length}
          </Text>
        )}

      </Page>
        );
      })}
    </Document>
  );
}
